<template>
  <el-dialog
    :visible="true"
    :before-close="handleClose"
    :title="$t('设置设备数据发送间隔')"
    width="500px"
    class="data-send-interval-settings"
    top="30vh"
  >
    <HTForm v-bind="formOptions" :i18nPath="i18nPath"></HTForm>
  </el-dialog>
</template>

<script>
import HTForm from '@/components/form/index.vue';
import { setSendDataInterval } from '@/api/devices';
import { awaitTo } from '@/utils/utils';

export default {
  components: {
    HTForm
  },
  props: {
    sn: {
      type: String,
      default: ''
    },
    container: {
      type: HTMLElement,
      default: () => document.body
    }
  },
  data() {
    return {
      i18nPath: 'part',
      status: 0,
      formOptions: {
        inline: true,
        config: {
          labelWidth: '',
          span: 18,
          options: [
            {
              type: 'select',
              prop: 'interval',
              labelNeedTranslation: true,
              dataKey: 'intervalList',
              placeholder: '请选择',
              label: '数据间隔'
            }
          ],
          operation: {
            span: 6,
            buttons: [
              {
                text: '保存',
                loading: false,
                type: 'primary',
                handler: async ({ data, setLoading, getFormRef }) => {
                  const formRef = getFormRef();

                  const valid = await formRef.validate();

                  if (!valid) return false;

                  setLoading(true);

                  await this.setSendInterval(data);

                  setLoading(false);
                }
              }
            ]
          }
        },

        model: {
          interval: 1
        },
        dataSource: {
          intervalList: Array(5)
            .fill()
            .map((_, i) => ({ label: `${i + 1}秒`, value: i + 1 }))
        },
        rules: {
          interval: [{ required: true, message: '请选择间隔', trigger: 'blur' }]
        }
      }
    };
  },
  methods: {
    handleClose(done) {
      this.$destroy();
      done?.();
    },
    async setSendInterval(data) {
      const [err, res] = await awaitTo(
        setSendDataInterval({
          sn: this.sn,
          dataInterval: data.interval
        })
      );

      if (err) {
        console.log(err);
      } else if (res?.message) {
        this.$message.success(this.$t('设置成功'));
      }

      this.handleClose();
    }
  },
  mounted() {
    document.body.appendChild(this.$el);
  },
  destroyed() {
    // if appendToBody is true, remove DOM node after destroy
    if (this.$el && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el);
    }
  }
};
</script>

<style lang="scss">
.data-send-interval-settings {
  box-sizing: border-box;
}
</style>
